export const numberOfAqiListItemsLoading = (numberOfItems = 6): number[] => Array.from(Array(numberOfItems).keys());

export const defaultText = '--';
export const aqiNoDataErrorStatusCode = 404;

export const aqiIndexLegend = [
    { 
        backgroundFillColor: '#A52018',
        indexRange: '80 - 100',
        aqiDescription: 'Poor',
        recommendation: 'People with lung disease, such as asthma, children, older adults, and outdoor workers should avoid prolonged or heavy outdoor exertion; everyone else should reduce prolonged or heavy outdoor exertion.'
    },
    { 
        backgroundFillColor: '#E71218',
        indexRange: '60 - 79',
        aqiDescription: 'Low',
        recommendation: 'People with lung disease, such as asthma, children, older adults, and outdoor workers should reduce prolonged or heavy outdoor exertion.'
    },
    { 
        backgroundFillColor: '#FAC52F',
        indexRange: '40 - 59',
        aqiDescription: 'Moderate',
        recommendation: 'Unusually sensitive people should consider reducing prolonged or heavy outdoor exertion.'
    },
    { 
        backgroundFillColor: '#82CE50',
        indexRange: '20 - 39',
        aqiDescription: 'Fair',
        recommendation: 'Air quality is acceptable for most people and suitable for outdoor activities; however, people should pay attention to changes in air quality.'
    },
    { 
        backgroundFillColor: '#518439',
        indexRange: '0 - 19',
        aqiDescription: 'Excellent',
        recommendation: 'Ideal air quality for outdoor activities and for those who have health sensitivities.'
    }
];

export const pollutantList = [
    'pm25',
    'pm10',
    'o3',
    'no2',
    'so2',
    'co'
] as const;